import { Auth } from 'aws-amplify';
import { takeEvery, fork, put, all } from "redux-saga/effects";
import i18n from 'i18next';
import { publicIpv4 } from 'public-ip';
import dictionary from "../../../config/dictionary"
//Account Redux states
import { REGISTER_USER, REGISTER_USER_CONFIRMATION, GET_PROVIDERS, GET_TERMS } from "./actionTypes";
import { registerUserSuccessful, registerUserFailed, registerProviders, registerTerms } from "./actions";
import { apiError, loginSuccess } from "../login/actions";

import serviceLogin from '../../../api/login.service';
import serviceSupplier from '../../../api/supplier.service';

import showToast from '../../../components/Common/viewNotification';

function* registerUser({ payload: { user } }) {
  try {
    const newUser = yield Auth.signUp({
      username: user.account,
      password: user.password,
      attributes: {
        email: user.email,
      },
    });
    yield put(registerUserSuccessful(newUser.user));
    showToast(i18n.t('messageRegister:sendCode'), 'success');
  } catch (error) {
    showToast(i18n.t('messageRegister:sendCodeError'), 'error');
    yield put(registerUserFailed(error.message));
  }
}

function* registerUserConfirmation({ payload: { user, confirmation, client, history } }) {
  try {
    yield Auth.confirmSignUp(user.account, confirmation.confirmation);
    yield loginUser({
      ...user
    });
    yield put(apiError(i18n.t("authentication:errorUser")));
    history.push("/", { from: "Register" })
  } catch (error) {
    showToast(i18n.t('messageRegister:sendCodeError'), 'error');
    yield put(registerUserFailed(error.message));
  }
}

function* loginUser(user) {
  try {
    const response = yield serviceLogin.loginCognito(user.email, user.password);
    const ip = yield publicIpv4();
    let json = {
      cognitoId: user.email,
      username: response.username,
      email: user.email,
      sessionIp: ip,
      name: user.fullname,
      codeSystem: process.env.REACT_APP_SYSTEM_CODE,
      registerLog: true,
      isRegister: '1',
    };
    yield registerProvider(user);
    return response;
  } catch (error) {
    yield put(apiError(error.message));
  }
}

function* registerProvider(user) {
  try {
    const json = {
      sapCodeSupplier: user.provider.code,
      positionWork: user.position,
      name: user.fullname,
      username: user.account,
      society: user.provider.society,
      state: "0",
      email: user.email,
      phone: user.phone,
      codeType: dictionary.configApp.type.codeTypeCOGNITO
    };
    yield serviceSupplier.saveSupplier(json);
    yield serviceSupplier.sendEmails({supplierId: user.provider.id, supplierName: user.provider.name, ...json});
  }
  catch (error) {
    yield put(apiError(error.message));
  }
}

async function login(jsonLogin) {
  await serviceLogin.registerUser(jsonLogin);

  if (jsonLogin.isRegister === '1') {
    const jsonRole = {
      roleCode: process.env.REACT_APP_ROL_PROVIDER_CODE,
      username: jsonLogin.username,
    }

    await serviceLogin.registerRole(jsonRole).then((r) => {
      return r.data !== undefined ? r.data : r.response.data;
    });
  }
  const response = await serviceLogin.getDataUser(jsonLogin).then((r) => {
    return r.data !== undefined ? r.data : r.response.data;
  });
  if (response.error === undefined) {
    window.sessionStorage.removeItem('errorSession');
    sessionStorage.setItem('user', JSON.stringify(response.rol));
    sessionStorage.setItem('menu', JSON.stringify(response.menu));
    window.location.href = '/';
  } else {
    sessionStorage.setItem('errorSession', JSON.stringify(response));
  }
}

function* getProviders({ payload: { json } }) {
  try {
    const response = yield serviceSupplier.getProviders(json).then((r) => {
      return r.data !== undefined ? r.data : r.response.data;
    });
    yield put(registerProviders(response));
  } catch (error) {
    showToast(i18n.t('messageRegister:sendCodeError'), 'error');
    yield put(registerUserFailed(error.message));
  }
}

function* getTerms() {
  try {
    const response = yield serviceSupplier.getTerms().then((r) => {
      return r.data !== undefined ? r.data : r.response.data;
    });
    yield put(registerTerms(response));
  } catch (error) {
    showToast(error.message, 'error');
  }
}

export function* watchUserRegister() {
  yield takeEvery(REGISTER_USER, registerUser);
  yield takeEvery(REGISTER_USER_CONFIRMATION, registerUserConfirmation);
  yield takeEvery(GET_PROVIDERS, getProviders);
  yield takeEvery(GET_TERMS, getTerms);
}

function* accountSaga() {
  yield all([fork(watchUserRegister)])
}

export default accountSaga
